



































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$, ID} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import ModalShare from '@/components/modals/ModalShare.vue'
import ModalUpload from '@/components/modals/ModalUpload.vue'
import CargaCielo from '@/model/resource/CargaCielo'
import * as Helper from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.get.deliveryGet.title'),
})

@Component({
  metaInfo,
  components: {ModalShare, ModalUpload},
})
export default class DeliveryGetView extends Vue {
  @Prop({type: [String, Number], required: true}) id!: ID
  @Prop({type: String, default: null}) hash!: string | null

  AppConfig = AppConfig

  carga = new CargaCielo() as CargaCielo

  get merchantListLength() {
    return Math.max(this.merchantLeftList.length, this.merchantRightList.length)
  }

  get merchantLeftList() {
    const listBarcodeCielo = this.carga.listBarcodeCielo
        .filter((it) => it.idStatusBracodeFk === 1)
        .map((it) => ({
          name: it.rg || '',
          value: it.serial || '',
        }))

    return [...listBarcodeCielo]
        .filter((it) => (it.name || '').toLowerCase() !== 'kit completo')
  }

  get merchantRightList() {
    const listBarcodeCielo = this.carga.listBarcodeCielo
        .filter((it) => it.idStatusBracodeFk === 2)
        .map((it) => ({
          name: it.rg || '',
          value: it.serial || '',
        }))

    const listChecklistEntrega = this.carga.listChecklistEntrega
        .filter((it) => it.tipoChecklistEntrega.$id === 2)
        .map((it) => ({
          name: 'Checklist Componentes',
          value: it.descricao || '',
        }))

    return [...listBarcodeCielo, ...listChecklistEntrega]
        .filter((it) => (it.value || '').toLowerCase() !== 'kit completo')
  }

  qtd(i: number) {
    if (this.merchantRightList[i] &&
        this.merchantRightList[i].name === 'Checklist Componentes' &&
        !this.merchantLeftList[i]
    ) {
      return ''
    }
    return '1'
  }

  async mounted() {
    await this.populate()

    await Helper.sleep(1000)

    if (this.$route.query.print === '1') {
      this.openPrint()
    }
  }

  async populate() {
    const hash = this.hash ? encodeURIComponent(this.hash) : undefined
    await this.carga.getCargaEspecial(this.id, hash)
  }

  openPrint() {
    window.print()
  }
}
